<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items="items"
  item-value='id'
  item-text='name'
)
</template>

<script>
import picker from '@/mixins/picker'

export default {
  data() {
    return {
      items: [
        { id: 0, name: 'не требуется' },
        { id: 1, name: 'от 1 года до 3 лет' },
        { id: 2, name: 'от 3 до 6 лет' },
        { id: 3, name: 'более 6 лет' }
      ]
    }
  },
  mixins: [picker],
  props: {
    label: {
      selected: 1
    }
  }
}
</script>
